import { Button, Divider, IconButton, List, ListItem, Toolbar, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { defineMessages, useIntl, FormattedMessage } from "react-intl";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deactivateTechnician, isTechnicianEnabled } from "../../../redux/manageLabourer/manageLabourerActions";
import CancelIcon from "../../common/icons/cancelIcon";
import { ManageLabourerPageFields } from "../manageLabourerFieldsList.js";
import LabourerEditForm from "./labourerEditForm";
import LabourerViewForm from "./labourerViewForm";
import { useLocalizedName } from "../../../globals/langHelpers";

const useStyles = makeStyles((theme) => ({
    drawerToolBar: {
        backgroundColor: "#E1E1E1",
    },
    drawerToolBarHeading: {
        fontSize: 20,
        fontWeight: 700,
        color: "#111111",
        letterSpacing: "-0.62px",
    },
    drawerToolBarSubHeading: {
        fontSize: 14,
        color: "#222222",
    },
    btn: {
        fontSize: 16,
        fontFamily: "Arial",
        color: "#00549A",
    },
    list: {
        display: "flex",
        justifyContent: "flex-end",
    },
    cancelCss: {
        position: "absolute",
        top: 4,
        right: 4,
        "&:hover": {
            backgroundColor: "none",
        },
    },
    divider: {
        width: "100%",
        padding: 10,
        justifyContent: "flex-end",
        alignItems: "center",
        position: "absolute",
        height: "5%",
        bottom: "10%",
    },
}));

const messages = defineMessages({
    labourerFormEditHeader: {
        id: "labourer-form.edit-header",
        defaultMessage: "Edit user",
        description: "Labourer edit title",
    },
    labourerFormEditSaveButton: {
        id: "labourer-form.edit-save-button-caption",
        defaultMessage: "Save changes",
        description: "Labourer edit save button caption",
    },
    labourerFormEditLinkButton: {
        id: "labourer-form.edit-link-button-caption",
        defaultMessage: "Edit profile",
        description: "Labourer edit link button caption",
    },
    labourerFormCreateHeader: {
        id: "labourer-form.create-header",
        defaultMessage: "Create user",
        description: "Labourer create title",
    },
    labourerFormCreateSaveButton: {
        id: "labourer-form.create-save-button-caption",
        defaultMessage: "Create user",
        description: "Labourer create save button caption",
    },
    labourerFormCreateLinkButton: {
        id: "labourer-form.create-link-button-caption",
        defaultMessage: "Create profile",
        description: "Labourer create link button caption",
    },
    labourerInactivatedCaption: {
        id: "labourer-form.labourer-inactivated-caption",
        defaultMessage: "inactivated",
        description: "Labourer inactivated header caption",
    },
});

function LabourerForm(props) {
    const classes = useStyles();
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();
    const { editFields, viewFields } = ManageLabourerPageFields;
    const { resetTechnicians, setResetTechinicians } = useState(false);
    const [fields, setFields] = useState([]);
    const [enableEdit, setEnableEdit] = useState({
        editform: false,
        createform: false,
        headerText: "",
        buttonText: "",
        linkText: "",
    });

    const setEditform = (edit) => (event) => {
        setEnableEdit({
            editform: edit,
            createform: false,
            headerText: intl.formatMessage(messages.labourerFormEditHeader),
            buttonText: intl.formatMessage(messages.labourerFormEditSaveButton),
            linkText: intl.formatMessage(messages.labourerFormEditLinkButton),
        });
    };

    useEffect(() => {
        if (props.state.create) {
            setEnableEdit({
                editform: false,
                createform: props.state.create,
                headerText: intl.formatMessage(messages.labourerFormCreateHeader),
                buttonText: intl.formatMessage(messages.labourerFormCreateSaveButton),
                linkText: intl.formatMessage(messages.labourerFormCreateLinkButton),
            });
        } else if (enableEdit.editform) {
            setEnableEdit({
                editform: true,
                createform: false,
                headerText: intl.formatMessage(messages.labourerFormEditHeader),
                buttonText: intl.formatMessage(messages.labourerFormEditSaveButton),
                linkText: intl.formatMessage(messages.labourerFormEditLinkButton),
            });
        }
        if (enableEdit.editform && enableEdit.createform) props.requestTechnicians();
    }, [props.state.create, enableEdit.editform, enableEdit.createform]);

    useEffect(() => {
        if (resetTechnicians === true) props.requestTechnicians();
    }, [resetTechnicians]);

    useEffect(() => {
        if (props.technician && props.technician["relatedKeycloakUserId"]) {
            props.isTechnicianEnabled(props.technician.relatedKeycloakUserId);
        }
    }, [props.technician]);
    return (
        <>
            <Toolbar className={classes.drawerToolBar}>
                {enableEdit.createform || enableEdit.editform ? (
                    <div>
                        <Typography variant="h6" component="h4" spacing={5}>
                            {enableEdit.headerText}
                        </Typography>
                    </div>
                ) : (
                    <div>
                        <Typography className={classes.drawerToolBarHeading}>{props.technician["labourerName"]}</Typography>
                        <Typography className={classes.drawerToolBarSubHeading}>
                            {getLocalizedName({ object: props.technician, value: "roleJobTitle" })}
                            {!props.isEnabled ? " - " + intl.formatMessage(messages.labourerInactivatedCaption) : ""}
                        </Typography>
                    </div>
                )}
                <div className={classes.cancelCss}>
                    <IconButton onClick={props.onclose(false)} disableRipple={true} disableFocusRipple={true}>
                        <CancelIcon />
                    </IconButton>
                </div>
            </Toolbar>
            <>
                {enableEdit.createform || enableEdit.editform ? (
                    <LabourerEditForm
                        {...props}
                        buttonText={enableEdit.buttonText}
                        fields={editFields}
                        handelSave={((val) => setResetTechinicians(val), props.onclose(false))}
                    />
                ) : (
                    <div>
                        <LabourerViewForm {...props} fields={viewFields} />
                        {props.showFooter && (
                            <div className={classes.divider}>
                                <Divider variant="middle" />
                                <List spacing={1}>
                                    <ListItem className={classes.list}>
                                        <Button variant="text" className={classes.btn} onClick={setEditform(true)}>
                                            <FormattedMessage
                                                id="labourer-form.footer.edit-profile-button-caption"
                                                defaultMessage="Edit profile"
                                                description="Labourer edit profile button caption"
                                            />
                                        </Button>
                                    </ListItem>
                                    <ListItem className={classes.list}>
                                        <Button
                                            variant="text"
                                            className={classes.btn}
                                            onClick={(event) =>
                                                props.deactivateTechnician(props.technician["relatedKeycloakUserId"], !props.isEnabled)
                                            }>
                                            {props.isEnabled ? (
                                                <FormattedMessage
                                                    id="labourer-form.footer.deactivate-profile-button-caption"
                                                    defaultMessage="Deactivate profile"
                                                    description="Labourer deactivate profile button caption"
                                                />
                                            ) : (
                                                <FormattedMessage
                                                    id="labourer-form.footer.activate-profile-button-caption"
                                                    defaultMessage="Reactivate profile"
                                                    description="Labourer activate profile button caption"
                                                />
                                            )}
                                        </Button>
                                    </ListItem>
                                </List>
                            </div>
                        )}
                    </div>
                )}
            </>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            deactivateTechnician,
            isTechnicianEnabled,
        },
        dispatch,
    );

const mapStateToProps = (state) => {
    return {
        isEnabled: state.isSelectedTechnicianEnabled,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LabourerForm);
